function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 14V9.294c0-3.833-2.953-7.175-6.785-7.29A7 7 0 0 0 9 9v5H8a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V17a3 3 0 0 0-3-3zM10 9c0-3.308 2.692-6 6-6s6 2.692 6 6v5h-1V9c0-2.757-2.243-5-5-5s-5 2.243-5 5v5h-1zm10 5h-8V9a4 4 0 0 1 8 0zm4 15H8a2 2 0 0 1-2-2V17a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2m-6-9a2 2 0 1 0-3.13 1.649l-.631 3.155A1 1 0 0 0 15.22 26h1.56a1 1 0 0 0 .981-1.196l-.631-3.155c.525-.361.87-.964.87-1.649m-1.851 1.845L16.78 25h-1.56l.631-3.155.129-.647-.544-.373A1 1 0 0 1 15 20c0-.551.449-1 1-1s1 .449 1 1c0 .329-.163.637-.436.825l-.544.373z",
    style: {
      fill: "#0b1719"
    }
  }));
};
export default SvgLock;